<app-banner [heading]="'HOUSE CLUB COMPETITIONS'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
	<!-- ======= About Section ======= -->
    <section id="events3" class="events3">
      <div class="container">
	  <!-- November -->
		 <h5><b>Inter House World Science Day Competition  (11/11/2021)<br>
				Winners :-</b> <br>
				Shakespeare House :-Angad (VII)<br>
				Wordsworth House :- Vaani (IX) <br>
				Shelley House :-Shivam Talwar (VII) <br> 
				Overall, Shakespeare house got first position with 10 pts and second position was won by Wordsworth and shelley house with 9 pts. <br> </h5>
	  <div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/nov (4).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/nov (5).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/nov (6).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>

	  <!-- October -->
	  <h5><b> Salad Competition (16/10/2021)</b><br>
	  <b>Winners :- </b><br>
	  Pre-Nur :- Aditya, Amoha, Divyam <br>
	  Nursery :- Mehreen, Rehnoor, Mohan <br>
	  Ukg :- Anaaya, Chirag, Rayansh. <br>
	  Grade I :- Samarth and khwaish, Harsirat and Eesvi, Dhruv<br>
	  Grade II :- Bhavika, Yashveer, Rittam kakkar <br>
	  Grade III :- Aarohi, Rishabh, Nilesh <br>
	  Grade IV :- Rudra Walia, Aditya Malik &amp; Jasleen Kaur, Mayank <br>
	  Grade VI :- Neetsay, shivee , kavya, Shikha <br>
	  Grade VII :- Anvi, Ishan, Tanveer <br> </h5><h5>
	  <div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (5).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (6).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (7).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>
	  </h5><h5> <b>Inter House Dance Competition (09/10/2021)<br>
	  Winners :- </b> <br>
		 <b>Junior Wing :- </b> <br>
		 Coleridge House :- Aahana &amp; Medhanshi (V) <br>Coleridge House got First position  <br>
		 <b>Senior Wing :- </b><br>Shakespeare House :-Angel(VII) <br> 
			Wordsworth House :-Harshita(IX) &amp; Ekam (VI), Vanika (VI) <br>
			Coleridge House :-Mannat (VIII) <br>
			Shelley House :- Shivee (VI)  <br>
			Overall Wordsworth and Coleridge house got first position and second position won by Shelley House <br></h5><h5>
			<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (4).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (3).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (2).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>

 </h5><h5><b>Intra House Dance Competition (05/10/2021)</b> <br>
			 <b>Winners :- </b><br>
			Shakespeare House :- <br>
			Grade I :-Harsirat <br>
			Grade IV :- Sanaya  <br>
			Grade V :- Raghvi <br>
			Grade VI :- kavya, saachi <br>
			Grade VII :- Angel ,Shenoy &amp; Aastha <br>
			Grade VIII :- Garvita <br>
			Wordsworth House <br>
			Grade III :- Zoya, Atharv <br>
			Grade IV :- Amoli <br>
			Grade VI :- Vanika, Ekam <br>
			Grade VII :- Navneet, Jasmine <br>
			GradeIX :- Harshita <br>
			Coleridge House <br>
			Grade I:- Khwaish <br>
			Grade V :- Aahana &amp; jiyanshi, Medhanshi &amp; Sakshi <br>
			Grade VI :- Shikha, Priyanka <br>
			Grade VII :- Japneet, Manmeet <br>
			Grade VIII :- Hardik, Mannat <br>
			Shelley house :- <br>
			Grade III :- Aarohi ,Moxita <br>
			Grade V :- Arnav kalyan ,Pranav &amp; Nikunj <br>
			Grade VI :- Shivee, Shruti <br> </h5><h5>
			<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (10).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (9).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/october (8).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		</div>

<!-- September -->
			</h5><h5><b> Inter House Singing Competition (06/09/2021) </b><br>
			<b>Winners :- </b> <br>
			<b> Junior Wing:- </b> <br>
			Shakespeare house :- Harsirat <br>
			Wordsworth house :- Bhavika <br>
			Coleridge house :- Tejasveer, Harry <br>
			Shelley house :- Devik, Samarth, Manya <br>
			Overall ,shelley house got First position and second position won by Coleridge house. <br>
			<b>Senior Wing :- </b> <br>
			Shakespeare house :- Garvita <br>
			Coleridge house :- Manmeet <br>
			Shelley house :- Shivee <br>
			Overall Shelley house got first position and second position won by Coleridge house	 <br></h5><h5>
			<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/september (7).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/september (5).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/september (4).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>
	  </h5><h5>  <b>Intra House Singing Competition  (01/09/2021) </b> <br>
	  <b>Winners :- </b>
			Shakespeare House <br>
			Grade I Harsirat <br>
			Grade III Swastik <br>
			Grade VI kavya, Saachi <br>
			Grade VII :-Aastha ,Jayant  and Tanveer <br>
			Grade VIII :- Garvita <br>
			Wordsworth House :- <br>
			Grade II :- Bhavika <br>
			Grade IV :- Parthv<br>
			Grade VI :- Aarush<br>
			Grade VII :- Shivam ,Navneet &amp; Jasmine <br>
			Coleridge House  <br>
			GradeIII :- Harry <br>
			Grade IV :- Tejasveer Singh <br>
			Grade VI :- Neetsey, Seerat ,Shikha <br>
			Grade VII :- Japneet Manmeet <br>
			Grade VIII :- Hardik, Mannat <br>
			Shelley house :- <br>
			Grade III :- Devik <br>
			Grade V :- Manya, Arnav <br>
			Grade VI :- Shivee, Shruti <br> </h5>
			<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/september (3).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/september (2).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/september (1).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		</div>
	  <!-- August -->
	 
 <h5> <b> Janmashtami Celebration (28/08/21 ) <br>
 Shelley house got 1st position with 38.5 points <br>Wordsworth house got 2nd position with 37 points </b></h5>
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/janmashtami (1).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/janmashtami (2).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/janmashtami (3).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/janmashtami (4).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/janmashtami (5).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/janmashtami (6).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  </div>
	 
	  <h5> <b>Inter House Quiz Competition (28/08/2021)<br>
	  Winners :- <br>
		Junior Wing :- </b><br>
		Shakespeare House :-Harkirat <br>
		Wordsworth House :- Rupica <br>
		Coleridge House :- Nikunj <br>
		Shelley House:- Harsdeep <br>
		Overall ,Shelley house got First position and second position won by Wordsworth and Coleridge house. <br>
		<b>Senior Wing :- </b> <br>
		Shakespeare House :-Garvita, Tanveer <br>
		Wordsworth House :- Vaani, Harshita <br>
		Coleridge House :-Neetsay, Hardik <br>
		Shelley House:- Shivam Talwar,Amit <br>
		Overall Shelley house got first position and second position won by Wordsworth house </h5>
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (1).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (2).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (3).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  </div>
	  <h5> <b>Inter House Calligraphy Competition (25/08/2021)<br>
		Junior Wing:- </b><br> Shakespeare House (9pts) :- Noel,Tejas <br>
		Shelley House(9pts):-Sujal <br>
		Coleridge House :-Hardik <br>
		<b>Senior Wing :- </b><br>
		Shakespeare House(10pts):- Ishmeet,Gurnoor <br>
		Wordsworth House(9pts) :-Harshita <br>
		Coleridge House :- Riyaarth <br> </h5>
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (5).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (6).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (7).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		</div>
	  <h5> <b>Rakhi Making Competition (21/08/2021)<br>
	  Winners:- </b><br>
		Grade I :- Shivaansh, Ritvij, Kavya, Paakhi, kavyanjali <br>
		Grade II :-Harleen, Manya, Aarvin, Arnav <br>
		Grade III :-Devansh, Noel, Swastik, Jasnoor, Kavish, Moxita, Anirudh <br>
		Grade IV :- Gurnoor Singh, Sanaya, Uddish, Daksh <br>
		Grade V :-Harkirat, Manya, Sujal, Raghvi, Damandeep, Sakshi <br>
		Grade VI :-Shivee, Nishtha , Parul <br>
		Grade VII :- Jasmine, Angad, Shivam, Aastha <br>
		Grade VIII :- Mannat <br>
		Grade IX :- Harshita </h5>
<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (8).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (10).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (11).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>
	  <h5><b>Intra House Quiz Competition (19/08/2021) <br>
	  Winners :-  </b><br>
		Grade I :- Charish, Khwaish <br>
		Grade II :-Rupica, Archika <br>
		Grade V :-Sujal, Rahi, Arnav Bohay, Gayatri, Nikunj, Harkirat, Harshdeep <br>
		Grade VI :-Aarush, Neetsay <br>
		Grade VII :-Shivam Talwar&amp; Amit, Shivam <br>
		Grade VIII :-Garvita Mitali Mannat Hardik <br>
		Grade IX :- Harshita, Vaani, Ketan <br></h5>
<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (12).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (13).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>
	  <h5><b> Intra House Calligraphy Competition (18/08/2021) <br>
	  Winners :- </b><br>
		Grade I :-Ritvij, Aradhya Charish, kritika, Advit <br>
		Grade II :-Bhavika <br>
		Grade III :-Noel, Devik, Ansh, Zoya <br>
		Grade IV :- Parth, Hardik, Sanaya, Jasleen kaur <br>
		Grade V :-Sujal,Arnav Bohay, Tejas ,Harshdeep <br>
		Grade VI :- Himanshi, Vanika, Neetsay, Kunal <br>
		Grade VII :-Riyaarth, Aastha, Kunal <br>
		Grade VIII :-Garvita, Chakshu, Dhruv <br>
		Grade IX :-Harshita, Ishmeet, Gurnoor, Kanishka <br> </h5>
<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (15).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (16).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (17).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  </div>
	  <h5> <b>Bangle Decoration Competition (11/08/2021) <br>
	  
	  Winners:- </b><br>
		Grade I :- Ayan <br>
		Grade III :-Jasnoor, Devansh<br>
		Grade IV:-Sujal, Harkirat <br>
		Grade VI :-Ishan, Veer, Vanika Saini <br> </h5>
<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (18).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div> 	
	  <h5><b>Mehndi Decoration Competition (11/08/2021) <br>
		Winners :- </b><br>
		Grade I :-Kavyanjali <br>
		Grade II:-Bhavika <br>
		Grade III :-Zoya <br>
		Grade IV :-Aditya <br>
		Grade V :-Manya <br>
		Grade VI :-Shikha <br>
		Grade VII :-Anni <br>
		Grade IX :-Gurnoor <br> </h5>
<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (19).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (20).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div> 	
	  <h5> <b>Intra House Declamation Competition  (10/08/2021)<br>
	  Winners:-</b> <br>
		Grade I :-Armaan &amp; Shnaya, Harsimrat, Shivaansh <br>
		Grade II:- Bhavika <br>
		Grade V :-Sujal, Harkirat <br>
		Grade VI :- Vanika, Shikha <br>
		Grade VII :-Shivam Talwar, Tanveer <br>
		Grade VIII :-Dhruv	<br>
		Grade IX :- Vaani 	</h5>
		<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (21).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (22).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/august (23).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  </div>
	  <!-- August -->
	  <!-- July -->
	<h5><b> Inter House Creative Writing  Competition (29/07/2021)<br>
	Junior Wing :-  </b> <br>
	Wordsworth House(10pts) <br>
	Anirudh<br>
	<b>Senior Wing :-</b><br>
	Wordsworth House(10pts) <br>
	Vanika, Hansmeet<br>
	Coleridge House <br>
	Mannat, Saachi</h5>
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (1).jpg" alt="best school in kurukshetra">
            </div>
          </div>		  
	</div>
	<h5><b> Inter House Extempore Competition (28/07/2021)<br>
	 Winners :- <br>Junior Wing :- </b> <br> 
	Shelley House :-Devik, Vineet, Sujal, Medhanshi <br>
	Shakespeare House :- Armaan, Arpit, Harkirat <br>
	Wordsworth House :-Harsirat, Anirudh, Rupika <br>
	Coleridge House :- Shnaya, Shivaansh, Lamar, Dhanvi <br>
	In junior wing Shelley and Coleridge House got 1st position with 10 marks and 2 nd position won by Wordsworth house with 9 pts <br>
	<b>Senior Wing :- </b><br>
	Shakespeare House :- Tanveer, Jayant <br>
	Wordsworth House :- Jasmine <br>

In senior wing Shakespeare house got 1st position with 10 pts and 2nd position won by Wordsworth House.</h5>
	<div class="row">
		<!--<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (2).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->
		<div class="col-md-4 d-flex align-items-stretch">
		<div class="card">
              <img src="assets/img/competition/july (3).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		<div class="col-md-4 d-flex align-items-stretch">
		  <div class="card">
              <img src="assets/img/competition/july (4).jpg" alt="best school in kurukshetra">
            </div>
          </div>		  
	</div>
	<h5><b> Intra House No Stove Cooking Competition (17/07/2021)</b><br> Winners :- <br>
Grade I:- 1. Samarth, 2. Tejaswini, 3. Khwaish <br>
Grade II :- 1. Rupica, 2. Archika <br>
Grade III :- 1. Zoya, 2. Swastik, 3. Anirudh, 4. Atharv <br>
Grade IV :- 1. Hardik, 2. Arnav Mehla <br>
Grade V :- 1. Sujal, 2. Nikunj, 3.Medhanshi, 4.Harkirat <br>
Grade VI :-1. Vanika, 2. Nishtha <br>
Grade VII :- 1. Kunal, 2. Anvi, 3. Tanveer <br>
Grade VIII :- 1. Garvita</h5>
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (5).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		<div class="col-md-4 d-flex align-items-stretch">
		<div class="card">
              <img src="assets/img/competition/july (6).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  		  
	</div>
	<h5><b> Intra House Creative Writing Competition (10/07/2021)</b><br>Winners :- <br>
	Grade I :- 1. Samarth, 2. Kavyanjali <br>
	Grade II :-1. Shaurya, 2. Divyaansh, 3. Yashveer <br>
	Grade III :- 1. Zoya, 2. Devik <br>
	Grade IV :- 1. Parth, 2. Hitansh, 3. Sanaya <br>
	Grade VI:-	1. Ekam, 2. Aarav <br>
	Grade VII:- 1. Kunal, 2.Shivam Talwar <br>
	Grade IX :- 1.Harshita</h5> 
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (7).jpg" alt="best school in kurukshetra">
            </div>
          </div>
	<div class="col-md-4 d-flex align-items-stretch">
		<div class="card">
              <img src="assets/img/competition/july (8).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		<div class="col-md-4 d-flex align-items-stretch">
		  <div class="card">
              <img src="assets/img/competition/july (9).jpg" alt="best school in kurukshetra">
            </div>
          </div>		  
	</div>	
	<h5><b> Intra House Extempore Competition (05/07/2021)</b><br> Winners :- <br>
	Grade I :- 1.Advit, 2. Samarth, 3. Aradhya <br>
	Grade II :- 1. Rupica, 2. Divyansh, 3. Rittam, 4.Bhavika <br>
	Grade III :- 1. Zoya, 2. Ansh, 3. Atharv <br>
	Grade IV :- 1. Aditya, 2. Parth, 3. Sanaya <br>
	Grade V :- 1. Medhanshi, 2.Arnav kalyan, 3. Sujal <br>
	Grade VI :- 1. Vanika, 2. Khadija, 3. Neetsay <br>
	Grade VII :- 1. Rudra, 2. Riyaarth <br>
	Grade VIII :- 1. Hardik, 2. Mannat <br>
	Grade IX :- 1. Ishu, 2.Harshita</h5>
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
		<div class="card">
              <img src="assets/img/competition/july (10).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		<div class="col-md-4 d-flex align-items-stretch">
		  <div class="card">
              <img src="assets/img/competition/july (11).jpg" alt="best school in kurukshetra">
            </div>
          </div>		  
	</div>
	<h5><b> Intra House Bag Making Competition (03/07/2021) <br>
	Winners :-</b> <br>
Pre-nur :- Aditya, Charvi <br>
Nursery :-Yashaswini, Meheeen, Saksham <br>
LKG :- Upkaran, Guruhanspreet <br>
UKG :Nityam &amp; Aarush, Kritik &amp; Rihaan, Vrinda &amp; Vedansh <br>
Grade I :- Ritvij, Samarth &amp; kavya <br>
Grade II :-Yashveer, Archika <br>
Grade III :- Zoya, Jasnoor &amp; Atharv <br>
Grade VI :- Aditya, Viren <br>
Grade V :- Turyana Harkirat,&amp; Arnav <br>
Grade VI :- Ekam, Ruhani &amp; Vanika <br>
Grade VII :-Navneet, Jayant &amp; Krish <br>
Grade VIII :- Mannat  <br>
Grade IX :- Harshita<br></h5>
	<div class="row">
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (14).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		<div class="col-md-4 d-flex align-items-stretch">
		<div class="card">
              <img src="assets/img/competition/july (15).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		<div class="col-md-4 d-flex align-items-stretch">
		  <div class="card">
              <img src="assets/img/competition/july (17).jpg" alt="best school in kurukshetra">
            </div>
          </div>		  
	</div>
	<h5><b> Intra House First-Aid Box Making Competition (01/07/2021) <br>
	Winners :- </b><br>
	Grade II :- Bhavika, Shayla <br>
Grade III :- Rishab, Anirudh <br>
Grade IV :- Vinnet, Krish <br>
Grade V :- Gayatri, Dikshita <br>
Grade VI :- Ekam, Himanshi <br>
Grade VII :- Jasmine, Jayant <br>
Grade IX :-Harshita<br></h5>	
	<div class="row">
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (18).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (19).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/july (20).jpg" alt="best school in kurukshetra">
            </div>
          </div>
	</div>
	 
		


	 <!-- May -->
	<h5> <b>	Inter House Yoga Competition  (28/05/2021) <br> Winners :- <br>
				Junior Wing :-</b><br> Shelley House : Mitansh, Rishab, Ansh,  Vineet Sujal.<br>
									Shakespeare House : Jasamrita, Swastik, Hitansh <br>
									 Wordsworth House : Hanisha , Zoya , Turanya <br>
									 Coleridge House : Samarth, Mayan <br>
									 In Junir Wing  Shelley House:- 1st  with 10 Marks and Wordsworth &amp; Shakespeare House :-2nd with 9 Marks <br>
				<b> Senior Wing :- </b> <br> Shakespeare House :- Tanveer , Jayant , Pankaj <br>
									 Wordsworth House :- Ekam, Jasmine , Harshita <br>
									 Shelley House :- Neetsay , Manmat <br>
									 In Senior Wing  Shakespeare House :- 1st with 10 Marks and Wordsworth House :- 2nd with 9 Marks </h5>
		<div class="row">
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (4).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (3).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (2).jpg" alt="best school in kurukshetra">
            </div>
          </div>
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (1).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->
		 </div>
	<h5> <b>Inter House Story Weaving Competition  (25/05/2021) <br> Winners:- <br>
					Junior Wing :-</b><br>
					Shelley House :- Mitanshi, Harsirat , Aarohi, Devik, Sansthita, Ansh, Tejasveer, Jasleen, Sujal<br>
					Shakespear House :- Ayan, Dakshita, Divit, Devansh, Harkirat. <br>
					Coleridge House :- Sangram, Damandeep, Nikunj <br>
					In Junior Wing :- Shelley House :-1st with 10 Marks and Shakespear House :-2nd with 9 Marks.<br>
					<b> Senior Wing :- </b> <br>
					Coleridge House:- Shikha, Seerat, Neetsay, Khadija, Shivam Talwar, Jasleen <br>
					Wordsworth House :- Ekam, Vanika, Aarush, Jasmine, Kunal, Harshita, Vaani, Kanishka <br>
					Shakespear House :- Kamaljot, Nistha, Kunal, Saachi, Tanveer, Angad, Jayant, Pankaj, Ishu <br>
					In Senior Wing :- Coleridge House:- 1st with 10 Marks.
					
					</h5>
		<div class="row">
           <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (11).jpg" alt="best school in kurukshetra">
            </div>
          </div> 
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (10).jpg" alt="best school in kurukshetra">
            </div>
          </div>
-->
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (9).jpg" alt="best school in kurukshetra">
            </div>
          </div>
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (8).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (7).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (6).jpg" alt="best school in kurukshetra">
            </div>
          </div>
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (5).jpg" alt="best school in kurukshetra">
            </div>
          </div>-->
		  </div>
		
		  		
		<h5><b>Intra House Yoga Competition  (05/05/2021)<br> 
				Winners :-</b> <br> Grade II :- 1. Bhavika, 2. Divyansh<br>
				Grade III :- 1. Atharav, 2. Swastik<br>
				Grade IV :- 1. Krish<br>
				Grade V :- 1. Harkirat <br>
				Grade VI :- 1. Ekam, 2. Shivee<br>
				Grade VII :- 1. Tanveer, 2. Anvi<br>
				Grade VIII :- 1. Mannat, 2. Hardik</h5>
          <div class="row">
<!--          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (16).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (15).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (14).jpg" alt="best school in kurukshetra">
            </div>
          </div>

		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (13).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (12).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  </div>
		<h5><b> Intra House Story Telling Competition (03/05/2021)</b><br>
				 Winners :- <br>Grade II :-1. Bhavika, 2. Divyansh<br>
				 Grade III :- 1. Atharv, 2. Swastik<br>
				 Grade IV :- 1. Krish<br>
				 Grade V :- 1. Harkirat<br>
				 Grade VI :-1. Ekam, 2. Shiveen<br>
				 Grade VII : 1. Tanveer, 2. Anvi<br>
				 Grade VIII :- 1. Mannat, 2. Hardik<br>
				 Grade IX :- 1. Harshita</h5>
          <div class="row">

		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (18).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (17).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		</div>
        
		 <h5> <b> Inter House Art Competition ( Best out of waste) (29/04/2021)</b><br>
				   Winners :- <br>Shakespeare House (9 pts)<br>
				   Gurnoor Grade IX<br>
				   Wordsworth House (10 pts)<br>
				   Harshita Grade IX <br>
				   Coleridge House (9 pts) <br>
				   Dhanvi Grade IV <br>
				   Shelley House (8 pts) <br>
				   Riyaarth Grade VII</h5>
         <div class="row"> 
		  <!--<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (25).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (24).jpg" alt="best school in kurukshetra">
            </div>
          </div>
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (23).jpg" alt="best school in kurukshetra">
            </div>
          </div>
	-->
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (22).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (21).jpg" alt="best school in kurukshetra">
            </div>
          </div>
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (20).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (19).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->
		</div> 

		 <h5> <b> Inter House Slogan Writing Competition on Earth Day  (22/04/2021) </b> <br> Winners <br>
				<b>Junior Wing :-</b><br> Shakespear House (10pts)<br>
					Bhavika Grade II , Harkitar Grade V<br>
					Wordsworth House (9pts)
					Eeshvi Grade I, Arnav Kalyan Grade V <br>
					Coleridge House <br>
					Zoya Grade III<br>
					Shelley House <br>
					Samarth Grade I, Anirudh Grade III<br>
				<b>Senior Wing :- </b><br>Shakespear House(10pts)<br>
				Gurnoor Grade IX, Kavya Grade VI<br>
				Wordworth House <br>
				Harshita Grade IX, Dikshant VII<br>
				Coleridge House <br>
				Neetsay Grade VI <br>
				Shelley House <br>
				Anvi Grade VII
				</h5>
         <div class="row">
         <!-- <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (29).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (28).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (27).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (26).jpg" alt="best school in kurukshetra">
            </div>
          </div> -->
		</div>
 <h5> <b>Intra House Poster Making Competition  (15/04/2021) </b><br>
		 Winners :- <br> Grade I :- 1. Ritvij, 2. Khwaish <br>
		  Grade II :- 1. Shanvik, 2. Yashveer<br>
		  Grade IV :- 1. Jasleen<br>
		  Grade V :- 1. Harkirat, 2. Gayatri<br>
		  Grade VI :- 1. Ekam, 2. Vanika <br>
		  Grade VII :- 1. Tanveer, 2. Anvi <br>
		  Grade VIII :- 1. Garvita, 2. Mannat<br>
		  Grade IX :- 1. Jasleen, 2. Khushi</h5>
		<div class="row">
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (33).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (32).jpg" alt="best school in kurukshetra">
            </div>
          </div>
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (31).jpg" alt="best school in kurukshetra">
            </div>
          </div>
	-->

		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (30).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>
		 <h5><b>Healthy Tiffin Box Competition   (07/04/2021)</b></h5>
			<h5> Winners :- <br> Grade I : 1. Shivaansh , 2.Yugam<br>
							Grade II : 1. Harleen , 2. Rittam <br>
							Grade III : 1. Atharv, 2. Rishab<br>
							Grade IV : 1. Naksh , 2. Aditya Malik &amp; Krish <br>
							Grade V : 1. Sujal, 2. Jiyanshi <br>
							Grade VI : 1. Shikha, 2. Aarush <br>
							Grade VII : 1. Shivam Talwar, 2. Riyarth <br>
							Grade VIII : 1. Garvita <br>
							Grade IX :- 1. Ishu </h5>
						   
		<div class="row">
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (38).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (37).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (36).jpg" alt="best school in kurukshetra">
            </div>
          </div>
<!--
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (35).jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (34).jpg" alt="best school in kurukshetra">
            </div>
          </div>-->
		</div>
		
		<div> <h5><b>Inter House Art Competition  (03/04/2021)</b></h5>
			<h5> Winners :-<br><b> Junior Wing :-</b> Rupika ,Hardik   <br>
						   <b>Senior Wing :- </b>Ishu, Vanika , Garvita, Shikha, Shivee, Khushi</h5>
		</div>
		<div class="row">
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (41).jpg" alt="best school in kurukshetra">
            </div>
          </div>
	<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (40).jpg" alt="best school in kurukshetra">
            </div>
          </div>
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <img src="assets/img/competition/a (39).jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 </div>
		
		
		 
          
		</div>
      
	</section><!-- End About Section -->
	
  </main>
